/* eslint-disable no-param-reassign */

import { types } from "mobx-state-tree";
import BaseChat from "data/models/chat/base";

const HistoryChatsModel = types
  .model("HistoryChatsModel", {
    items: types.array(BaseChat),
  })
  .actions((self) => ({
    set(values) {
      self.items = values;
      return self;
    },

    add(chat) {
      self.items.push(chat);
      return self;
    },

    remove(chatId) {
      self.items = self.items.filter((v) => v.id !== chatId);
      return self;
    },

    removeAll() {
      self.items = [];
      return self;
    },
  }))
  .views((self) => ({
    byId(chatId) {
      return self.items.find((chat) => chat.id === chatId);
    },

    hasChat(chatId) {
      return self.items.some((chat) => chat.id === chatId);
    },
  }));

export default HistoryChatsModel;
